// extracted by mini-css-extract-plugin
export default {"fields":"styles-scoped__fields--Squj_"};